import EventCalendar from "../../components/eventCalendar/eventCalendar";

const CalendarAppointments = () => {
  const events = [
    {
      title: "Meeting with Bob",
      message: "Discuss project milestones and next steps ",
      email: "yourmail@mail.com",
      phone: "(123) 456-7890",
      start: new Date(),
      end: new Date(),
    },
    {
      title: "Call to Jhon",
      message: "Discuss project milestones and next steps",
      email: "yourmail@mail.com",
      phone: "(123) 456-7890",
      start: new Date(),
      end: new Date(),
    },
    {
      title: "Meeting with David",
      message: "Discuss project milestones and next steps ",
      email: "yourmail@mail.com",
      phone: "(123) 456-7890",
      start: new Date(),
      end: new Date(),
    },
    {
      title: "Call to Robert",
      message: "Discuss project milestones and next steps",
      email: "yourmail@mail.com",
      phone: "(123) 456-7890",
      start: new Date("2025-08-30T10:45:00"),
      end: new Date("2025-08-30T11:00:00"),
    },
    {
      title: "Meeting with Jason",
      message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.",
      email: "yourmail@mail.com",
      phone: "(123) 456-7890",
      start: new Date(),
      end: new Date(),
    },
  ];

  return (
    <div className="page-content calendar-page">
      <div className="container-fluid">
        <div className="calendar-grid">
          <EventCalendar events={events} />
        </div>
      </div>
    </div>
  );
};

export default CalendarAppointments;
